const ActionType = {
  SIGNIN_ERROR: "SigninAction.SIGNIN_ERROR",
  SIGNIN_LOADING: "SigninAction.SIGNIN_LOADING",
  SIGNIN_SUCCESS: "SigninAction.SIGNIN_SUCCESS",
  SIGNIN_USER: "SigninAction.SIGNIN_USER",
}

export default ActionType
